<template>
  <div class="home">
    <!-- main section -->
    <section
      class="main-section bg-cover d-flex align-items-center justify-content-center"
      :style="{'background-image': `url(${homeCover})`}"
    >
    <!-- <img src="../../assets/app/images/cover1.png" alt=""> -->
      <div class="intro">
        <h1 class="dark-heading">{{ $t('intro-text') }}</h1>
        <h3 class="light-heading">Vacation Mode On</h3>
      </div>
    </section>
    <!--end main section -->

    
    <section class="products py-5 mt-3">
      <div class="container">
        <div class="row justify-content-center">
          <div class="col-sm-8 col-md-6 col-lg-4 mb-3" v-for="product in products" :key="product.id">
            <Product :product="product"/>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
// @ is an alias to /src
import "../../sass/homepage.scss";
import homeCover from '../../assets/app/images/cover1.png';
import Product from "../../components/app/Product";
import {firestore} from "../../firebase";
export default {
  name: "home",
  components: {
    Product
  },
  data() {
    return {
      homeCover,
      products: []
    }
  },
    firestore() {
    return {
      products: firestore.collection("products")
    };
  },
};
</script>
